import { Button } from '@ps-design-system/components/Button';
import {
  FunctionalCard,
  FunctionalCardContent,
  FunctionalCardHeader,
  FunctionalCardTitle
} from '@ps-design-system/components/cards/FunctionalCard';
import {
  PriceSummary,
  PriceSummaryRow,
  PriceSummaryTotalRow
} from '@ps-design-system/components/PriceSummary';
import CloseIcon from '@ps-design-system/icons/X/X20';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const AddOnsPriceSummary = ({
  addOnsContracts,
  addOnsTotal,
  addOnsSalesTax,
  currency,
  SSOid,
  onClose
}) => {
  return (
    <FunctionalCard
      style={{ width: '320px', border: 'none', backgroundColor: 'transparent' }}
    >
      <FunctionalCardHeader className="tw-items-center tw-justify-between">
        <FunctionalCardTitle>
          <FormattedMessage
            id="price_summary.add_on_price_details"
            defaultMessage="Add-on price details"
          />
        </FunctionalCardTitle>
        <Button variant="text-only" iconOnly={true} onClick={onClose}>
          <CloseIcon />
        </Button>
      </FunctionalCardHeader>

      <FunctionalCardContent className="tw-text-gray-900">
        <PriceSummary testId="add-on-price-summary">
          {(addOnsContracts || []).map((contract) => {
            return (
              <>
                <PriceSummaryRow
                  testId="add-on-line-item"
                  key={contract._id}
                  name={(
                    <div className="tw-flex">
                      <span className="truncate">{contract.meta?.label}</span>
                      <span className="margin-sm-left">
                        <span className="margin-sm-right">x</span>
                        <span className="margin-sm-right">
                          {contract.units}
                        </span>
                        {contract.meta?.unit_cost_basis === 'per_hour' && (
                          <span>
                            <FormattedMessage
                              id="price_summary.hours_short"
                              defaultMessage="hrs"
                            />
                          </span>
                        )}
                      </span>
                    </div>
                  )}
                  value={(
                    <FormattedNumber
                      value={contract.primary_amount?.[SSOid]}
                      currency={currency}
                      style="currency"
                    />
                  )}
                />
                {(contract?.secondary_charges || []).map((charge) => (
                  <PriceSummaryRow
                    testId="add-on-line-item"
                    key={charge._id}
                    name={(
                      <div className="truncate">{charge?.meta?.label}</div>
                    )}
                    value={(
                      <FormattedNumber
                        value={charge?.amount}
                        currency={currency}
                        style="currency"
                      />
                    )}
                  />
                ))}
              </>
            );
          })}

          <PriceSummaryRow
            testId="add-on-sales-tax"
            name={(
              <FormattedMessage
                id="price_summary.add_on_sales_tax"
                defaultMessage="Add-on sales tax"
              />
            )}
            value={(
              <FormattedNumber
                value={addOnsSalesTax}
                currency={currency}
                style="currency"
              />
            )}
          />

          <PriceSummaryTotalRow
            testId="add-on-total"
            name={(
              <FormattedMessage
                id="price_summary.add_on_total"
                defaultMessage="Add-on total"
              />
            )}
            value={(
              <FormattedNumber
                value={addOnsTotal}
                currency={currency}
                style="currency"
              />
            )}
          />
        </PriceSummary>
      </FunctionalCardContent>
    </FunctionalCard>
  );
};

AddOnsPriceSummary.displayName = 'AddOnsPriceSummary';
AddOnsPriceSummary.propTypes = {
  addOnsContracts: PropTypes.array,
  addOnsTotal: PropTypes.number,
  currency: PropTypes.string,
  SSOid: PropTypes.string,
  onClose: PropTypes.func,
  addOnsSalesTax: PropTypes.number
};
